import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InsuranceDTO } from '../../../api/useInsuranceQuery';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';

interface Props {
  data: InsuranceDTO;
}

export const LifeInsurancePermanentType = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  const options = data.Options.LifeInsurancePermanentTypeOptions;

  return (
    <Controller
      control={formBag.control}
      name="LifeInsurancePermanentType"
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            label="Benefit Type"
            value={options.find(opt => opt.value === value)}
            options={options}
            onChange={opt => onChange(opt?.value)}
            isPortal
          />
        );
      }}
    />
  );
};
